var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIconGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31947",
    "data-name": "Group 31947",
    transform: "translate(18 18) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 18,
    height: 18,
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900",
    transform: "translate(17.25 17.25) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66169",
    "data-name": "Path 66169",
    d: "M8.25,1.375A6.875,6.875,0,1,1,1.375,8.25,6.883,6.883,0,0,1,8.25,1.375M8.25,0A8.25,8.25,0,1,0,16.5,8.25,8.25,8.25,0,0,0,8.25,0",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_900-2",
    "data-name": "Group 900",
    transform: "translate(4.063 4.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_422",
    "data-name": "Line 422",
    d: "M7.625,1.5H.75A.75.75,0,0,1,.75,0H7.625a.75.75,0,1,1,0,1.5Z",
    transform: "translate(0 3.437)",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_423",
    "data-name": "Line 423",
    d: "M.75,8.375A.75.75,0,0,1,0,7.625V.75a.75.75,0,0,1,1.5,0V7.625A.75.75,0,0,1,.75,8.375Z",
    transform: "translate(3.437)",
    fill: "#808080"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconGrey);
export default __webpack_public_path__ + "static/media/plus-icon-grey.3c310466ae7be13e9a168398ea624bbe.svg";
export { ForwardRef as ReactComponent };